"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _constants = require("./constants");

var BlogNotificationEmail =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(BlogNotificationEmail, _Record);

  function BlogNotificationEmail(props) {
    (0, _classCallCheck2.default)(this, BlogNotificationEmail);

    if (props.enabled === undefined) {
      props.enabled = props.is_published;
    }

    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BlogNotificationEmail).call(this, props));
  }

  return BlogNotificationEmail;
}((0, _immutable.Record)({
  blog_email_name: null,
  blog_email_type: null,
  blog_email_type_label: null,
  enabled: null,
  from_name: null,
  id: null,
  portal_id: null,
  reply_to: null,
  subscription_blog_id: null
}, _constants.BLOG_NOTIFICATION_EMAIL));

exports.default = BlogNotificationEmail;
module.exports = exports.default;